import React, { useState, useEffect } from 'react';
import api from 'services/api';

const Leitura = () => {
    const [data, setData] = useState([]);

    useEffect(() => {
        api.get('/empresa/').then((response) => {
            let arr = [];
            arr = formatArray(response.data);
            console.log(arr)
            setData(arr)
        });
    }, []);

    function verificaleitura(diaLeitura) {
        const hoje = new Date();
        const diaAtual = hoje.getDate();

        let diasRestantes;
        if (diaLeitura >= diaAtual) {
            diasRestantes = diaLeitura - diaAtual;
        } else {
            const ultimoDiaMes = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0).getDate();
            diasRestantes = (ultimoDiaMes - diaAtual) + parseInt(diaLeitura);
        }

        if (diasRestantes <= 2) {
            return "red";
        } else if (diasRestantes > 2 && diasRestantes < 5) {
            return "green";
        } else {
            return "none";
        }
    }

    const formatArray = (data) => {
        let arr = [];
        let leituraStatus;
        data.map((elem) => {
            leituraStatus = verificaleitura(elem.NR_DIA_LEITURA)
            if (leituraStatus != "none") {
                arr.push({
                    id: elem.OID_EMPRESA,
                    cnpj: elem.NR_CNPJ,
                    razao: elem.NM_RAZAO_SOCIAL,
                    cep: elem.CD_CEP,
                    telefone: elem.NR_TELEFONE,
                    endereco: elem.DS_LOGRADOURO + ", " + elem.NR_LOGRADOURO + ", " + elem.DS_BAIRRO + ".",
                    checked: elem.TP_ENVIO === "S" ? true : false,
                    log: elem.DS_LOGRADOURO,
                    nr: elem.NR_LOGRADOURO,
                    bairro: elem.DS_BAIRRO,
                    diaLeitura: elem?.NR_DIA_LEITURA ? parseInt(elem.NR_DIA_LEITURA) : 0,
                    leituraStatus: leituraStatus
                });
            }
        });

        arr.sort((a, b) => a.diaLeitura - b.diaLeitura);
        return arr;
    };

    // The entire banner will only be rendered if data has items
    return (
        data.length > 0 && (
            <div style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                width: '100%',
                backgroundColor: '#fff',
                padding: '2px',
                boxShadow: '0 -2px 5px rgba(0,0,0,0.1)',
                textAlign: 'center',
                zIndex: 9999,
                overflow: 'hidden',
                whiteSpace: 'nowrap'
            }}>
                <div style={{
                    display: 'inline-block',
                    animation: 'scroll 40s linear infinite',
                }}>
                    <style>
                        {`
                            @keyframes scroll {
                                from { transform: translateX(0); }
                                to { transform: translateX(-50%); }
                            }
                        `}
                    </style>
                    
                    {/* First content block with a 500px margin on the right to create a gap */}
                    <span style={{display: 'inline-block', marginRight: '300px'}}>
                        <span><strong>Próximas Leituras: &nbsp;</strong></span>
                        {data.map((item, index) => (
                            <span key={item.id} style={{ marginRight: '10px' }}>
                                {item.razao} - Dia:<span style={{ color: item.leituraStatus }}>{item.diaLeitura}</span>
                                {index < data.length - 1 ? '    ' : ''}
                            </span>
                        ))}
                    </span>

                    {/* Second content block that will appear after the gap */}
                    <span style={{display: 'inline-block'}}>
                        <span><strong>Próximas Leituras: &nbsp;</strong></span>
                        {data.map((item, index) => (
                            <span key={`${item.id}-clone`} style={{ marginRight: '10px' }}>
                                {item.razao} - Dia:<span style={{ color: item.leituraStatus }}>{item.diaLeitura}</span>
                                {index < data.length - 1 ? '    ' : ''}
                            </span>
                        ))}
                    </span>
                </div>
            </div>
        )
    )
}

export default Leitura;